import { Tooltip, Typography, TypographyProps } from '@material-ui/core';
import { useState, useEffect, useRef } from 'react';
import { CustomTypograhy } from './Typograhy';

type RepresentativesTypograhyProps = {
  children?: string;
} & TypographyProps;

export const TypographyTooltip = ({ children, ...props }: RepresentativesTypograhyProps) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLSpanElement | null>(null);

  // Function to check if the text is truncated
  const checkTruncation = () => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  };

  // Initialize ResizeObserver
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      checkTruncation(); // Check truncation when the component is resized
    });

    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    // Clean up observer on unmount
    return () => {
      if (textRef.current) {
        resizeObserver.unobserve(textRef.current);
      }
    };
  }, []); // Only run once on mount

  return (
    <Tooltip title={children || ''} disableHoverListener={!isTruncated}>
      <CustomTypograhy
        ref={textRef}
        noWrap
        {...props}
        style={{ fontSize: 14, width: '100%', cursor: isTruncated ? 'pointer' : undefined, ...props.style }}
      >
        {children}
      </CustomTypograhy>
    </Tooltip>
  );
};
